module.exports = __webpack_public_path__ + "img/banner2.204f1deb.png";